export default "__VITE_ASSET__SWtXKOqc__"